export enum HIR_CURRENCY {
  coins = 'coins',
  card_pack = 'card_pack',
  elite_points = 'elite_points',
  pinata = 'pinata'
}
